@for (d of devices; track d.device_key) {
  <div class="pm-banner" role="status">
    <mat-icon class="pm-banner__icon">speed</mat-icon>
    <div class="pm-banner__text">
      <strong>{{ (high(d) ? 'pm_hint.title_high' : 'pm_hint.title_low') | translate }}</strong>
      <span class="pm-banner__body">
        {{ (high(d) ? 'pm_hint.body_high' : 'pm_hint.body_low')
           | translate: { device: d.label || ('pm_hint.device_fallback' | translate),
                          n: d.n_rides, pct: pct(d.mean) } }}
      </span>
      @if (d.bike_assumed) {
        <span class="pm-banner__note">
          {{ 'pm_hint.bike_assumed' | translate: { kg: (d.bike_kg | number: '1.0-1') } }}
        </span>
      }
      @if (!canOpenTool) {
        <span class="pm-banner__note">{{ 'pm_hint.locked' | translate }}</span>
      }
    </div>
    <span class="grow"></span>
    @if (canOpenTool) {
      <a mat-flat-button color="primary"
         [routerLink]="['/tools/pm-validation']"
         [queryParams]="{ athlete: athleteId, device: d.device_key }">
        {{ 'pm_hint.banner_cta' | translate }}
      </a>
    }
    <button mat-icon-button (click)="dismiss()" [attr.aria-label]="'pm_hint.dismiss' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
